import React from "react";
import mapServiceItem from "./mapServiceItem";

export default function ProductionServiceList({ items }) {
    return (
        <div className="production-service-list">
            {items.map((item) => {
                const card = mapServiceItem(item);

                return (
                    <article className="production-service-item" key={card.title}>
                        <span className="production-service-num">{card.marker}</span>
                        <div>
                            <h3>{card.title}</h3>
                            <p>{card.text}</p>
                            <div className="production-mini-tags">
                                {card.tags.map((tag) => (
                                    <span key={tag}>{tag}</span>
                                ))}
                            </div>
                        </div>
                    </article>
                );
            })}
        </div>
    );
}
